module.exports = __webpack_public_path__ + "static/media/1 0 Orddiktat Intro.3501b14a.mp3";